import client from '@/lib/http-client';

const endpoint = '/phone-verification';

export default {
	check(cb, errorCb) {
		const url = endpoint;
		client
			.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	generate(params, cb, errorCb) {
		const url = `${endpoint}/generate`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	verify(params, cb, errorCb) {
		const url = `${endpoint}/verify`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
};
